import { Icon } from '@zillow/constellation-10';
import { IconAIMagicFilled } from '@zillow/constellation-icons';

type Props = {
  title?: string;
};

const AIAssistedFieldIcon = ({ title = 'Drafted with AI' }: Props) => {
  return (
    <Icon
      size="md"
      css={{ color: 'icon.accent.purple.hero' }}
      render={<IconAIMagicFilled />}
      title={title}
      data-testid="AIAssistedFieldIcon"
    />
  );
};

export default AIAssistedFieldIcon;
